import { Component, OnInit, Output, Input, ViewChild, EventEmitter} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../Library/BaseComponent';
import { MasterDataService } from '../../Services/MasterDataService';
import { EntityCodes, DeviceAllocationTypes, DeviceTypes } from '../../Models/EnumModels';
import { StaffDevice } from '../../Models/RequestModels';
import { GenericMaster } from '../../Models/GlobalEntities';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import * as _ from "lodash";


@Component({
    selector: 'AddEditStaffDevice',
    templateUrl: './AddEditStaffDevice.html',
})

export class AddEditStaffDevice extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    @Input() PrimaryDeviceData: Array<StaffDevice>;
    @Input() BackupDeviceData: Array<StaffDevice>;
    ModalRef: NgbModalRef;
    Model: StaffDevice;
    DeviceList: Array<GenericMaster> = [];
    StaffName: string;
    IsDeviceEdited: boolean = false;
    DisableModalOpenEvent: boolean = false;


    @Output() CheckEnabledDevices: EventEmitter<boolean> = new EventEmitter<boolean>();
    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, public modalService: NgbModal) {
        super(translate, toastr, route, router, masterService);

    }
    ngOnInit(): void {
        //this.SetDefault();
    }

    Open(deviceData: any, ReqModel: any, AllocationType: number): void {
        if (this.DisableModalOpenEvent) return;
        if (deviceData) this.IsDeviceEdited = true;
        else this.IsDeviceEdited = false;  
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            centered: true
        };    

        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
       
        this.DisableModalOpenEvent = true;
        this.Model = new StaffDevice();
        this.Model.StaffId = ReqModel.StaffId;
        this.SetDefault();
        if (deviceData) {
            this.Model = _.cloneDeep(deviceData);
        }
        else {
            this.Model.DeviceAllocationType = AllocationType;
        }
        this.DeviceList = _.cloneDeep(this.masterService.GetAllDeviceType(ReqModel.PropertyId));
        if (AllocationType == DeviceAllocationTypes.Backup) {
            this.DeviceList = this.DeviceList.filter(obj => obj.Id == DeviceTypes.Email || obj.Id == DeviceTypes.SMS || obj.Id == DeviceTypes.Pager);
        }   
        

        this.ModalRef.result.then((result) => {
            // this.router.navigate(['Calls/JobConsole']);
        }, (reason) => {
            this.DisableModalOpenEvent = false;
        });
    }
    SetDefault(): void{
        //this.DeviceId = 0;
        this.Model.DeviceType = 0;
        this.Model.DeviceNumber = "";
        this.Model.IsEnabled = false;
        this.Model.DeviceName = "";
        this.ClearErrors();
    }
   
    SaveMapping(): void {
        if (this.Validated()) {
            this.Model.DeviceName = this.masterService.MasterData_GetMutli(this.masterService.LoggedInUserData.PropertyId, this.Model.DeviceType, EntityCodes.DeviceType, "")
            
            if (this.Model.DeviceAllocationType == DeviceAllocationTypes.Primary) {
                if (this.Model.DeviceId != undefined) {
                    let index = this.PrimaryDeviceData.findIndex(obj => obj.DeviceId == this.Model.DeviceId);
                    this.PrimaryDeviceData[index] = this.Model;
                }
                else {
                    let index = this.PrimaryDeviceData.findIndex(obj => obj.DeviceType == this.Model.DeviceType);
                    if (index >= 0) this.PrimaryDeviceData[index] = this.Model;
                    else this.PrimaryDeviceData.push(this.Model);
                }
            }
            else if (this.Model.DeviceAllocationType == DeviceAllocationTypes.Backup) {
                if (this.Model.DeviceId != undefined) {
                    let index = this.BackupDeviceData.findIndex(obj => obj.DeviceId == this.Model.DeviceId);
                    this.BackupDeviceData[index] = this.Model;
                }
                else {
                    let index = this.BackupDeviceData.findIndex(obj => obj.DeviceType == this.Model.DeviceType);
                    if (index >= 0) this.BackupDeviceData[index] = this.Model;
                    else this.BackupDeviceData.push(this.Model);
                }
            }

            this.CheckEnabledDevices.emit(true);
            this.ModalRef.close();
        }
    }
    SetField(): void {
        if (this.Model.DeviceType == 1 || this.Model.DeviceType == 6)
            this.Model.DeviceNumber = "";
        this.ClearErrors();
    }
    Validated(): boolean {
        this.ClearErrors();
        let regexEmail = /^([a-zA-Z0-9_.+-])+[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,})$/;

        if (this.Model.DeviceNumber != "")
            this.Model.DeviceNumber = this.Model.DeviceNumber.trim()

        if (!this.Model.DeviceType) {
            this.AddError('ERR.ERR_SELECT_DEVICE');
            return false
        }
        else if (this.Model.DeviceType != 1 && this.Model.DeviceType != 6 && this.Model.DeviceType != 3 && this.Model.DeviceNumber == "") {
            this.AddError('ERR.ERR_ENTER_DEVICE_NUMBER');
            return false
        }
        else if (this.Model.DeviceType == 3 && this.Model.DeviceNumber == "") {
            this.AddError('ERR.ERR_ENTER_VALID_EMAIL');
            return false
        }
        else if (this.Model.DeviceType == 2 && /^[a-zA-Z0-9]+$/.test(this.Model.DeviceNumber) == false) {
            this.AddError('ERR.ERR_ENTER_VALID_PAGER_NO');
            return false
        }
        else if (this.Model.DeviceType == 3 && !regexEmail.test(this.Model.DeviceNumber)) {
            this.AddError('ERR.ERR_ENTER_VALID_EMAIL');
            return false
        }
        else if (this.Model.DeviceType == 4 && /^\d\d*$/.test(this.Model.DeviceNumber)== false) {
            this.AddError('ERR.ERR_ENTER_VALID_MOBILE_NO');
            return false
        }
        else if (this.Model.DeviceType == 4 && this.Model.DeviceNumber.toString().length > 25) {
            this.AddError('ERR.ERR_MOBILE_NO_LENGTH_25');
            return false
        }
        else if (this.Model.DeviceType == 5 && /^[0-9\.]+$/.test(this.Model.DeviceNumber) == false) {
            this.AddError('ERR.ERR_ENTER_VALID_IP');
            return false
        }
        else if (this.Model.DeviceAllocationType == DeviceAllocationTypes.Backup) {
            for(let i = 0; i <this.BackupDeviceData.length; i++) {               
                if (this.Model.DeviceId && this.Model.DeviceNumber != "" && this.BackupDeviceData[i].DeviceNumber == this.Model.DeviceNumber && this.BackupDeviceData[i].DeviceId != this.Model.DeviceId) {
                    this.AddError('ERR.ERR_DUPLICATE_DEVICE');
                return false
            }
                else if (!this.IsDeviceEdited && !this.Model.DeviceId && this.BackupDeviceData[i].DeviceType == this.Model.DeviceType) {
                    this.AddError('ERR.ERR_DUPLICATE_DEVICE');
                return false
            }
                else if (!this.Model.DeviceId && this.Model.DeviceNumber != "" && this.BackupDeviceData[i].DeviceNumber == this.Model.DeviceNumber && this.BackupDeviceData[i].DeviceType == this.Model.DeviceType) {
                    this.AddError('ERR.ERR_DUPLICATE_DEVICE_NO');
                return false
            }
        }
           
        }
        else {
            for (let i = 0; i < this.PrimaryDeviceData.length; i++) {
               if (this.Model.DeviceId && this.Model.DeviceNumber != "" && this.PrimaryDeviceData[i].DeviceNumber == this.Model.DeviceNumber && this.PrimaryDeviceData[i].DeviceId != this.Model.DeviceId) {
                    this.AddError('ERR.ERR_DUPLICATE_DEVICE');
                    return false
                }
                else if (!this.IsDeviceEdited && !this.Model.DeviceId && this.PrimaryDeviceData[i].DeviceType == this.Model.DeviceType) {
                    this.AddError('ERR.ERR_DUPLICATE_DEVICE');
                    return false
                }
                else if (!this.Model.DeviceId && this.Model.DeviceNumber != "" && this.PrimaryDeviceData[i].DeviceNumber == this.Model.DeviceNumber && this.PrimaryDeviceData[i].DeviceType != this.Model.DeviceType) {
                    this.AddError('ERR.ERR_DUPLICATE_DEVICE_NO');
                    return false
                }
            }
        }
        return true;
    }
}
